export function RegexGenerator(expression: string): RegExp {
	try {
		return new RegExp(expression);
	} catch (error) {
		console.error('RegexGenerator error: ', {expression, error});
		return null;
	}
}
